import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import moment from 'moment';
import Icon from '../Icon';
import BaseText from '../BaseText';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import RowView from '../RowView';
import { scale } from '../../utils/scale.utils';
import { useTranslation } from 'react-i18next';
import { i18nNS, useComponentTKey } from '../../i18n';
import { selectCompanyCulture } from '../../store/selectors/auth.selector';
import { useSelector } from 'react-redux';

const SearchDateDisplay = (props) => {
  const { fromDate, toDate, subSearchType, dominantSearchType, hasHotel, hasCar } = props;
  const { t } = useTranslation(i18nNS.calendar);
  const { tKey } = useComponentTKey('monthNamesShort');
  const companyCulture = useSelector(selectCompanyCulture);

  const formatDate = (date) => {
    const month = t(tKey(moment(date).format('MMM')));
    const day = moment(date).format('D');
    const formatDate = 'dateFormats.' + (companyCulture === 'US' ? 'MMMD' : 'DMMM');
    return t(formatDate, { MMM: month, D: day });
  };
  const formatfromDate = () => {
    if (!fromDate) {
      if (dominantSearchType === 'hotel') {
        return 'Check-in';
      } else {
        return 'Depart';
      }
    }
    return formatDate(fromDate);
  };

  const formatToDate = () => {
    if (!toDate) {
      if (dominantSearchType === 'hotel') {
        return 'Check-out';
      } else {
        return t('common:Return');
      }
    }
    return formatDate(toDate);
  };

  const showSingleDate =
    (dominantSearchType === 'air' || dominantSearchType === 'rail') &&
    ((subSearchType === 'oneway' && !(hasHotel || hasCar)) || subSearchType === 'multicity');

  return (
    <View style={styles.containerRow}>
      <View>
        <Icon size={28} name="calendar" style={styles.iconStyle} color={Color.text.low} />
      </View>
      <RowView style={CommonStyles.flex1}>
        <BaseText style={CommonStyles.h2}>{formatfromDate()}</BaseText>
        {!showSingleDate && (
          <View style={styles.blackHypenContainer}>
            <View style={styles.blackHypen}></View>
          </View>
        )}
        {!showSingleDate && <BaseText style={CommonStyles.h2}>{formatToDate()}</BaseText>}
      </RowView>
    </View>
  );
};

const widthHypen = scale(35);
const styles = StyleSheet.create({
  containerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  blackHypenContainer: {
    width: widthHypen,
    ...CommonProperties.centerAlignment,
    ...CommonProperties.mx3,
  },
  blackHypen: {
    height: scale(2),
    width: widthHypen,
    backgroundColor: 'black',
  },
  iconStyle: {
    ...CommonProperties.mr3,
    alignSelf: 'flex-start',
  },
});

export default memo(SearchDateDisplay);
